import { useDraggable } from '@dnd-kit/core';
import { FC, ReactNode } from 'react';

interface Props {
    id: string;
    disabled?: boolean;
    children: ReactNode;
}

// TODO: create story
const DraggableComponent: FC<Props> = ({ id, disabled = false, children }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        isDragging: is_dragging,
    } = useDraggable({
        id,
    });

    const attributes_and_listeners = disabled ? undefined : { ...attributes, ...listeners };

    return (
        <div
            ref={setNodeRef}
            className={`transition-opacity ${is_dragging || disabled ? 'pointer-events-none cursor-not-allowed opacity-40' : 'opacity-100'}`}
            {...attributes_and_listeners}
        >
            {children}
        </div>
    );
};

export default DraggableComponent;
